<template>
    <v-container
        id="contact"
        fluid
        style="background-color: #3a83f6"
    >
        <v-row class="ma-12">
            <v-col>
                <v-img
                    src="@/assets/images/logo_white_large.png"
                    max-width="300"
                ></v-img>
            </v-col>
            <v-col>
                <div class="white--text display-1 ml-6">Hubungi Kami</div>

                <contact-list white></contact-list>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ContactList from './ContactList'

export default {
    components: {
        ContactList,
    },
}
</script>
